import { faFlag } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useContext } from 'react';

import { Color } from '@/constants/color';
import ENVIRONMENTS from '@/constants/environments';
import HOSTS from '@/constants/hosts';
import AppContext from '@/contexts/appContext';
import Button from '@/ui/components/Button';

import { Props } from './types';

const ReportIssueButton = ({ report_url, extraParameters }: Props) => {
  const { currentUser, host } = useContext(AppContext);

  const buildReportIssueUrl = (extraParameters: { [key: string]: string }) => {
    const environment = host.includes(HOSTS[ENVIRONMENTS.PRODUCTION]) ? 'production' : 'staging';

    const params = new URLSearchParams({
      'submitted-by': currentUser?.email ?? '',
      'dugout-url': window.location.href,
      environment: environment,
      ...extraParameters
    });
    return `${report_url}?${params.toString()}`;
  };

  return (
    <Button
      ariaLabel="Report this issue"
      color={Color.RED}
      onClick={() => {
        const reportUrl = buildReportIssueUrl({
          ...extraParameters
        });
        window.open(reportUrl, '_blank');
      }}
      size="xs">
      <FontAwesomeIcon icon={faFlag} className="mr-2" />
      Report this issue
    </Button>
  );
};

export default ReportIssueButton;
